const marqueeAnimations = new WeakMap();

function animateMarqueeSection(section) {
  if (!section) return;

  const paths = section.querySelectorAll("textPath");

  if (!paths.length) return;

  const speed = window.innerWidth < 749 ? 0.12 : 0.02;
  let offset = 0;

  cancelAnimationFrame(marqueeAnimations.get(section));

  function loop() {
    offset -= speed;

    if (offset <= -100) {
      offset = 0;
    }

    paths.forEach((path) => {
      path.setAttribute("startOffset", `${offset}%`);
    });

    marqueeAnimations.set(section, requestAnimationFrame(loop));
  }

  loop();
}

function animateMarquees(root = document) {
  const sections =
    root.matches?.(".index-marquee__text")
      ? [root]
      : root.querySelectorAll(".index-marquee__text");

  sections.forEach((section) => animateMarqueeSection(section));
}

document.addEventListener("DOMContentLoaded", () => animateMarquees());

document.addEventListener("shopify:section:load", (event) => {
  animateMarquees(event.target);
});






// let marqueeAnimation;
// let offset = 0;

// function animateMarquee() {

//   const paths = document.querySelectorAll("textPath");

//   if (!paths.length) return;

//   const speed = window.innerWidth < 749 ? 0.12 : 0.02;

//   function loop() {

//     offset -= speed;

//     if (offset <= -100) {
//       offset = 0;
//     }

//     paths.forEach((path) => {
//       path.setAttribute("startOffset", `${offset}%`);
//     });

//     marqueeAnimation = requestAnimationFrame(loop);
//   }

//   cancelAnimationFrame(marqueeAnimation);

//   loop();
// }

// document.addEventListener("DOMContentLoaded", animateMarquee);

// document.addEventListener("shopify:section:load", animateMarquee);